"use client";

import React from "react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const galleryImages = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/gallery_paris_eiffel.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/gallery_paris_eiffel.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/gallery_paris_eiffel.png-wvc-sizes",
  alt: "Torre Eiffel, Paris - Destino Internacional"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/gallery_rio_cristo.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/gallery_rio_cristo.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/gallery_rio_cristo.png-wvc-sizes",
  alt: "Cristo Redentor, Rio de Janeiro - Destino Nacional"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/gallery_rome_colosseum.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/gallery_rome_colosseum.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/gallery_rome_colosseum.png-wvc-sizes",
  alt: "Coliseu, Roma - Destino Internacional"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/gallery_fernando_noronha.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/gallery_fernando_noronha.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/gallery_fernando_noronha.png-wvc-sizes",
  alt: "Fernando de Noronha, Brasil - Destino Nacional"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/gallery_venice_canals.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/gallery_venice_canals.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/gallery_venice_canals.png-wvc-sizes",
  alt: "Canais de Veneza, Itália - Destino Internacional"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/gallery_lencois_maranhenses.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/gallery_lencois_maranhenses.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/gallery_lencois_maranhenses.png-wvc-sizes",
  alt: "Lençóis Maranhenses, Brasil - Destino Nacional"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/gallery_santorini_greece.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/gallery_santorini_greece.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/gallery_santorini_greece.png-wvc-sizes",
  alt: "Santorini, Grécia - Destino Internacional"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/gallery_gramado_rs.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/gallery_gramado_rs.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/gallery_gramado_rs.png-wvc-sizes",
  alt: "Gramado, Rio Grande do Sul - Destino Nacional"
}];
export default function PremiumTravelGallery() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="premiumtravelgallery" className="bg-background py-10 md:py-12">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-center !text-[rgba(27,164,172,1)]">
          <h2 className="font-default text-3xl font-semibold mb-4 !text-[rgba(27,164,172,1)] md:text-4xl">
            Inspirações pelo Mundo
          </h2>
          <p className="max-w-2xl mx-auto text-lg font-default !text-[rgba(27,164,172,1)]">
            Descubra destinos deslumbrantes, cuidadosamente selecionados para proporcionar experiências inesquecíveis e seguras.
          </p>
        </div>

        <div ref={ref} className={`grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6 transition-opacity duration-1000 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
          {galleryImages.map((image, i) => <div key={i} data-index={i} className="group relative overflow-hidden rounded-xl bg-muted shadow-sm">
              <AspectRatio ratio={3 / 4}>
                <img src={image.src} data-wvc-srcset={image.srcset} data-wvc-sizes={image.sizes} alt={image.alt} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-110" />
                {}
                <div className="absolute inset-0 bg-black/0 transition-colors duration-500 group-hover:bg-black/10 pointer-events-none" />
              </AspectRatio>
            </div>)}
        </div>
      </div>
    </section>;
}